import { css } from 'styled-components';
import { CFTokens } from '../../../tokens';
import { CFBaseToastTokens } from '.';
import { getIconBackgroundColor } from './utils';
export const actionsBorderColor = ({ alternateTheme, }) => alternateTheme
    ? CFBaseToastTokens.ACTIONS_BORDER_COLOR.ALTERNATE
    : CFBaseToastTokens.ACTIONS_BORDER_COLOR.DEFAULT;
export const iconWrapperVariants = ({ alternateTheme = false, hasAvatar, status = 'message', }) => {
    let borderColor = CFBaseToastTokens.ICON_BORDER_COLOR.DEFAULT, borderSize = 0;
    if (hasAvatar && alternateTheme) {
        borderColor = CFBaseToastTokens.ICON_BORDER_COLOR.ALTERNATE;
    }
    if (hasAvatar) {
        borderSize = 2;
    }
    return css `
    border: ${borderSize}px solid ${borderColor};
    background-color: ${CFTokens.getCFColorValue(getIconBackgroundColor({ alternateTheme, status }))};
  `;
};
export const rootBackgroundColor = ({ alternateTheme }) => alternateTheme
    ? CFBaseToastTokens.BACKGROUND_COLOR.ALTERNATE
    : CFBaseToastTokens.BACKGROUND_COLOR.DEFAULT;
export const rootCSSTransitions = ({ transitionState, }) => {
    switch (transitionState) {
        case 'entering':
            return css `
        display: flex;
        transform: translateY(100px);
        opacity: 0;
      `;
        case 'entered':
            return css `
        transform: translateY(0);
        opacity: 1;
      `;
        case 'exiting':
            return css `
        transform: translateY(100px);
        opacity: 0;
      `;
        case 'exited':
            return css `
        display: none;
      `;
    }
};
